<nav class="absolute z-999 bg-transparent">
  <div class="flex w-screen items-center justify-between px-4 py-5 lg:px-10">
    <a routerLink="/welcome">
      <img src="/img/logo.svg" alt="Logo" width="120" class="invert-100" />
    </a>
    @if (currentRoute() !== '/login') {
      <a
        routerLink="/login"
        class="rounded-md border border-white px-5 py-1 font-semibold text-white transition-colors duration-300 hover:border-black hover:bg-black hover:text-white sm:px-7">
        Iniciar Sesión
      </a>
    }
  </div>
</nav>
